import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../App.css';
import './loginPage.css';
import { loginUser, fetchCurrentUser } from '../../services/api';
import { UserContext } from '../UserContext/UserContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const { setUserContext } = useContext(UserContext);
  const [errorMessage, setErrorMessage] = useState('');
  const [fadeIn, setFadeIn] = useState(false);

  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  useEffect(() => {
    setFadeIn(true);
  }, []);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    var isAuthenticated = false;

    try {
      await loginUser(formData.username, formData.password);

      try {
        const currentUserData = await fetchCurrentUser();
        isAuthenticated = currentUserData.user.isAuthenticated;
        setUserContext({
          isAuthenticated: isAuthenticated,
          username: currentUserData.user.username,
          is_staff: currentUserData.user.is_staff,
          has_seen_confetti: currentUserData.user.has_seen_confetti,
        });
      } catch (error) {
        console.error('Erreur de fecthCurrentUser :', error);
        setErrorMessage("Erreur de récupération de l'utilisateur actuel");
      }
    } catch (error) {
      console.error('Erreur lors de la connexion :', error);
      setErrorMessage('Identifiant ou mot de passe incorrect(s)');
    }
    if (isAuthenticated) {
      navigate('/');
    }
  };

  return (
    <div className={`login-container${fadeIn ? ' fade-in' : ''}`}>
      <form onSubmit={handleSubmit}>
        <h2>Connexion</h2>
        <div className="form-group">
          <label>Nom d'utilisateur: </label>
          <input type="text" name="username" value={formData.username} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Mot de passe: </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
          />
        </div>
        <button type="submit">Se connecter</button>
        <p className="errorMessage">{errorMessage}</p>
      </form>
    </div>
  );
};

export default LoginPage;
